var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.orderList.length
    ? _c("section", { staticClass: "section_gap_y" }, [
        _c("p", { staticClass: "shop_label page-title" }, [
          _vm._v(_vm._s(_vm.$t("PRODUCT.ORDER_LIST.TITLE")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "variant_table_container" }, [
          _c("table", { staticClass: "variants" }, [
            _c("thead", [
              _c("tr", { staticClass: "row header" }, [
                _c("th", [
                  _vm._v(_vm._s(_vm.$t("PRODUCT.ORDER_LIST.TABLE.HEADER.NAME")))
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("PRODUCT.ORDER_LIST.TABLE.HEADER.AMOUNT"))
                  )
                ]),
                _vm._v(" "),
                _c("th", [
                  _vm._v(
                    _vm._s(_vm.$t("PRODUCT.ORDER_LIST.TABLE.HEADER.STATUS"))
                  )
                ])
              ])
            ]),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.orderList, function(order, accountId) {
                return _c("tr", { key: accountId, staticClass: "row" }, [
                  _c("td", [_vm._v(_vm._s(order.merchantName))]),
                  _vm._v(" "),
                  _c("td", { staticClass: "align_right" }, [
                    _vm._v(_vm._s(order.orderAmount))
                  ]),
                  _vm._v(" "),
                  _c(
                    "td",
                    [
                      _c("router-link", { attrs: { to: order.order_url } }, [
                        _vm._v(_vm._s(order.status))
                      ])
                    ],
                    1
                  )
                ])
              }),
              0
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }